// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

import wixWindow from 'wix-window';
import wixLocation from 'wix-location';


$w.onReady(function () {

    setTimeout(() => {

    if (wixWindow.formFactor === "Tablet") {
        wixLocation.to("https://www.mikelevin.org/?showmobileview=true");
        }
    }, 5000);

});


